import { Heading, Icon, Stack, Text, VStack } from '@chakra-ui/react';

import { FaTimesCircle } from 'react-icons/fa';
import { PageContainer, PageContent } from 'components';
import { usePageTextContent } from 'context/pageTextContent';
import { BenefitCard } from './BenefitCard';

export const BenefitsTypesSection = () => {
  const { content } = usePageTextContent<BenefitsPageContent>();

  const {
    title,
    description,
    sachbezug,
    sachbezugDescription,
    sachbezugFeatures,
    prasent,
    prasentDescription,
    prasentFeatures,
  } = content.benefitsTypes;

  return (
    <PageContainer bg="gray.100">
      <PageContent direction="column">
        <VStack spacing="1.5rem" w="full">
          <Heading fontSize="1.5rem">{title}</Heading>

          <Text whiteSpace="pre-line" textAlign="center" fontSize="1.125rem">
            {description}
          </Text>
        </VStack>

        <Stack
          direction={['column', 'column', 'row']}
          spacing={['1.5rem', '1.5rem', '4rem']}
          mt="4.375rem"
          align="stretch"
          justify="center"
        >
          <BenefitCard
            title={sachbezug}
            color="benefit.secondary"
            description={sachbezugDescription}
            features={sachbezugFeatures}
          />

          <Icon
            as={FaTimesCircle}
            fontSize="5rem"
            transform="rotate(-45deg)"
            color="benefit.secondary"
            alignSelf="center"
          />

          <BenefitCard
            title={prasent}
            color="benefit.primary"
            description={prasentDescription}
            features={prasentFeatures}
          />
        </Stack>
      </PageContent>
    </PageContainer>
  );
};
